module.exports = __webpack_public_path__ + "82ef7f4e8cb180b1fa6da6bd659c5aef.png";